module.exports = __webpack_public_path__ + "static/media/session-in-progress-icon.e80dc6ec.svg";